import { createStore } from '@'

export const $tableData = createStore('table:data')
export const $tableFilter = createStore('table:filter')
export const $tableLoading = createStore('table:loading')
